import { ComponentProps, useState } from 'react';
import AdminOnly from 'components/AdminOnly';
import { Button } from 'components/ui/button';
import { Settings } from 'lucide-react';
import { SchemaEditorDialog as PlantSchemaEditor } from '../PlantModule/SchemaEditorDialog';
import { SchemaEditorDialog as GsmSchemaEditor } from '../GsmPlant/SchemaEditorDialog';

type EditorProps = Pick<
  ComponentProps<typeof PlantSchemaEditor>,
  'customSchema' | 'metadata' | 'onSave'
> & {
  variant: 'plant' | 'gsm';
};

function SchemaEditorControl({ variant, ...props }: EditorProps) {
  const [open, setOpen] = useState(false);
  const Editor = variant === 'plant' ? PlantSchemaEditor : GsmSchemaEditor;
  return (
    <>
      <Button onClick={() => setOpen(true)} className="gap-2">
        <Settings className="h-4 w-4" />
        Rediger skema
      </Button>
      <Editor open={open} onOpenChange={setOpen} {...props} />
    </>
  );
}

export function InternalSchemaEditor(props: EditorProps) {
  return (
    <AdminOnly>
      <SchemaEditorControl {...props} />
    </AdminOnly>
  );
}

export function InternalSchemaDiagnostics({
  missingKeys,
  title,
  className,
  hideWhenEmpty = false,
}: {
  missingKeys: string[];
  title: string;
  className?: string;
  hideWhenEmpty?: boolean;
}) {
  return (
    <AdminOnly>
      {!hideWhenEmpty || missingKeys.length > 0 ? (
        <pre className={className}>
          {title}
          {JSON.stringify(missingKeys, null, 2)}
        </pre>
      ) : null}
    </AdminOnly>
  );
}
